import React, { useEffect, useState } from 'react';

const STEPS = [5, 10, 20, 25, 50, 100, 200, 250, 500, 1000, 2000, 5000];

function niceLength(meters) {
  for (let i = 0; i < STEPS.length; i += 1) {
    if (STEPS[i] >= meters) return STEPS[i];
  }
  return STEPS[STEPS.length - 1];
}

function metersPerPixel(camera, canvasHeight, distance) {
  const fov = ((camera.fov || 35) * Math.PI) / 180;
  const worldH = 2 * Math.tan(fov / 2) * Math.max(distance, 1);
  return worldH / Math.max(canvasHeight, 1);
}

export default function ScaleBar({ three, visible = true }) {
  const [label, setLabel] = useState('100 m');
  const [widthPx, setWidthPx] = useState(80);

  useEffect(() => {
    if (!visible || !three?.camera) return undefined;
    let id = 0;
    const tick = () => {
      const cam = three.camera;
      const canvas = three.gl?.domElement;
      const target = three.controlRef?.current?.target;
      if (cam && canvas && target) {
        const dist = cam.position.distanceTo(target);
        const mpp = metersPerPixel(cam, canvas.clientHeight || 1, dist);
        const targetM = mpp * 90;
        const metres = niceLength(targetM);
        const nextLabel = `${metres} m`;
        const nextWidth = Math.round(Math.max(36, Math.min(160, metres / mpp)));
        setLabel((prev) => (prev === nextLabel ? prev : nextLabel));
        setWidthPx((prev) => (prev === nextWidth ? prev : nextWidth));
      }
      id = requestAnimationFrame(tick);
    };
    tick();
    return () => cancelAnimationFrame(id);
  }, [three, visible]);

  if (!visible) return null;

  return (
    <div className="absolute bottom-3 right-3 z-[55] pointer-events-none">
      <div className="rounded-sm border border-yellow-600/40 bg-black/80 px-2 py-1.5 backdrop-blur-sm">
        <div className="h-1 bg-yellow-500" style={{ width: `${widthPx}px` }} />
        <p className="text-[9px] uppercase tracking-wider text-yellow-400 mt-1 tabular-nums text-center">
          {label}
        </p>
      </div>
    </div>
  );
}

export function scaleBarOverlaySpec(camera, canvas, target) {
  if (!camera || !canvas) return null;
  const dist = target
    ? camera.position.distanceTo(target)
    : camera.position.length();
  const mpp = metersPerPixel(camera, canvas.clientHeight || canvas.height || 1, dist);
  const metres = niceLength(mpp * 90);
  const widthPx = Math.max(36, Math.min(160, metres / mpp));
  return { metres, widthPx, label: `${metres} m` };
}
